import { useEffect, useState } from 'react';
import { useHeaderContext } from '../../context/headerContext';
import Button from '../../components/Button';
import { useUserContext } from '../../context/userContext';
import fetchWithRefresh from '../../utils/fetchWithRefresh';
import { toast } from "react-toastify";
import * as Sentry from "@sentry/react";
import { LogErrors } from "../../utils/LogErrors";
import { format } from 'date-fns';

export default function AccountRedeemBandSuccess() {
    const { user, logout, updateTokens, selectedVenue } = useUserContext();
    const { setTitle, setBackButton } = useHeaderContext();
    const [redeemBandDetails, setRedeemBandDetails] = useState(null);
 
    const fetchUserRedeemBandStatus = async () => {
        return await Sentry.startSpan({ name: "Fetch User Redeem Band Status", op: "http.request" }, async (span) => {
          try {
            const url = `${import.meta.env.VITE_API_URL}Cart/AccountRedemptionStatus?UserLoginId=${user?.id}`;
            span.setAttribute("http.url", url);
            span.setAttribute("user_id", user?.id);
            span.setAttribute("org_id", selectedVenue?.OrgID);
  
            const req = await fetchWithRefresh(url, {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${user?.token}`,
              },
            }, logout, updateTokens, (message) => { toast.info(message); });
      
            if (req.status === 200) {
              const res = await req.json();
              setRedeemBandDetails(res);
            } else {
              Sentry.captureMessage(`Failed to fetch redeem band status: ${req.status}`, "warning");
              LogErrors(user, logout, updateTokens, "Could not redeem band status.");
            }
      
            span.setStatus(req.ok ? "ok" : "error");
          } catch (error) {
            Sentry.captureException(error, { extra: { user_id: user?.id, org_id: selectedVenue?.OrgID } });
            LogErrors(user, logout, updateTokens, "Error fetching redeem band status: " + error);
          }
        });
    };

    useEffect(() => {
        setTitle("SUCCESS");
        setBackButton(false);
        fetchUserRedeemBandStatus();
    }, []);

    if(!redeemBandDetails) return;

    return (
        <div className='flex flex-col gap-6'>
            <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 20C1 9.23045 9.73045 0.5 20.5 0.5C31.2696 0.5 40 9.23045 40 20C40 30.7696 31.2696 39.5 20.5 39.5C9.73045 39.5 1 30.7696 1 20Z" fill="#47B405" stroke="#E3E3E3"/>
                <path d="M18.0466 27.3902C18.4372 27.7929 19.1013 27.7929 19.4919 27.3902L30.9763 15.5497C31.3669 15.1469 31.3669 14.4623 30.9763 14.0595L29.57 12.6097C29.1794 12.2069 28.5544 12.2069 28.1638 12.6097L18.7888 22.2754L14.3747 17.7647C13.9841 17.362 13.3591 17.362 12.9684 17.7647L11.5622 19.2146C11.1716 19.6173 11.1716 20.302 11.5622 20.7047L18.0466 27.3902Z" fill="white"/>
            </svg>
            <h2>Band Redeemed</h2>
            <p>Your free band has successfully been redeemed! Please allow 3-5 days for delivery.</p>
            <p className="text-[#6F6F6F]">You’ll be able to redeem your next free band on or after {format(new Date(redeemBandDetails?.AllowanceRenewalDate), 'dd/MM/yyyy')}</p>
            <div className='flex flex-col gap-4 pt-6 border-dashed border-t border-[#E3E3E3]'>
                <Button href="/" className="w-full">Go Home</Button>
            </div>
        </div>
    );
};